import React, { useEffect } from "react";
import Footer from "../Layout/Footer";
import Header from "../Layout/Header";
import { gpColors } from "../../constants/colors";
import {
    Button,
    makeStyles,
    Link,
    Box,
    Container,
    TextField,
    Snackbar,
    IconButton,
    Grid,
    Paper
} from "@material-ui/core";
import { experimentalStyled as styled } from '@material-ui/core';

import SendIcon from "@material-ui/icons/Send";
import CloseIcon from "@material-ui/icons/Close";
import { useState } from "react";
import usePhoneSize from "../../constants/usePhoneSize";
import useTabletSize from "../../constants/useTabletSize";
import { useNavigate } from "react-router-dom";
import { routes } from "../../constants/routes";
import img2 from '../../Images/img2.jpg'



const useStyles = makeStyles((theme) => ({
    container: {
        padding: "30px",
        fontSize: "14.5px",
        marginTop: "75px",
        [theme.breakpoints.up("sm")]: {
            marginTop: "105px",
        },
    },
    aboutContainer: {
        padding: "15px",
        fontSize: "14.5px",
    },
    heading: {
        fontWeight: 900,
        fontSize: "20px",
        height: "53px",
        background: "#36404b",
        margin: "0px",
        lineHeight: "58px",
        letterSpacing: "1px",
        textAlign: "center",
        color: "#fff",
        position: "relative",
        width: "260px",
        marginBottom: "30px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        "&:before": {
            content: "''",

            left: "-20px",
            borderStyle: "solid",
            borderWidth: "0 0 53px 20px",
            borderColor: `transparent transparent ${gpColors.logoBrown} transparent`,
            position: "absolute",
        },
        "&:after": {
            content: "''",
            right: "-20px",
            borderStyle: "solid",
            borderWidth: "53px 20px 0 0",
            borderColor: `${gpColors.logoBrown} transparent transparent transparent`,
            position: "absolute",
        },
    },
    content: {
        fontSize: "14.5px",
        fontWeight: 600,
        lineHeight: 2,
    },
    textFieldStyle: {
        width: "100%",
        [theme.breakpoints.only("xs")]: {
            width: "115%",
        },
        "& label.Mui-focused": {
            color: "Blue",
        },
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: "Blue",
            },
            "&:hover fieldset": {
                borderColor: "Blue",
            },
        },
    },
}));


function AllBlogs() {
    const classes = useStyles();
    const phonesize = usePhoneSize()
    const tabletsize = useTabletSize()
    const navigate = useNavigate();

    useEffect(() => {
        // console.log('rendered')
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }, []);

    const [successSubmit, setSuccessSubmit] = useState(false);
    const handleCloseSuccess = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setSuccessSubmit(false);
    };

    return (
        <div>
            <Header />
            <Container>
                <div className={classes.container}>
                    <div
                        style={{
                            textAlign: "center",
                            display: "flex",
                            justifyContent: "center",
                            marginBottom: '30px'
                        }}
                    >
                        <div className={classes.heading}>Blogs</div>
                    </div>

                    <Box
                        sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            textAlign: "justify",
                            fontSize: "16px",
                        }}
                    >
                    <Box sx={{ width: '100%', height: 'auto',  }}>
                        <Grid container rowSpacing={3} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid item xs={tabletsize ? phonesize ? 12 : 6 : 4} sx={{}}>
                                {/* <Box>1</Box> */}
                                <Box sx={{}}>
                                <Box sx={{'&:hover': {cursor: 'pointer'}}} onClick={()=>navigate(routes.BLOG1)}>
                                <img src={img2} alt={'Image uploading'} height='100%' width='80%' />
                                </Box>
                                <Box sx={{'&:hover': {cursor: 'pointer'}}} onClick={()=>navigate(routes.BLOG1)}><h2 style={{textAlign:'justify'}}>Comparing Different Engine Air Filter Materials: Which One is Right for You?</h2></Box>
                                    <Box sx={{}}>
                                        <p>The engine air filter is a critical component of your vehicle's engine system. In this blog post, we will compare various engine air filter materials and help you determine which one suits your needs best.</p>
                                    </Box>
                                    <Button onClick={()=>navigate(routes.BLOG1)} size="small">read more...</Button>
                                </Box>
                            </Grid>
                            {/*<Grid item xs={tabletsize?phonesize?12:6:4}>
                        <Box sx={{marginRight:'20px',marginLeft:'20px',}}>
                        <img src={img2} alt={'Image uploading'} height='100%' width='100%' />
                            <h2>Comparing Different Engine Air Filter Materials: Which One is Right for You?</h2>
                            <Box sx={{}}>
                            <p>The engine air filter is a critical component of your vehicle's engine system. In this blog post, we will compare various engine air filter materials and help you determine which one suits your needs best.</p>
                            </Box>
                            <p>read more..</p>
                        </Box>
                        </Grid>*/}
                        {/*<Grid item xs={tabletsize?phonesize?12:6:4}>
                        <Box sx={{marginRight:'20px',marginLeft:'20px',}}>
                        <img src={img2} alt={'Image uploading'} height='100%' width='100%' />
                            <h2>Comparing Different Engine Air Filter Materials: Which One is Right for You?</h2>
                            <Box sx={{}}>
                            <p>The engine air filter is a critical component of your vehicle's engine system. In this blog post, we will compare various engine air filter materials and help you determine which one suits your needs best.</p>
                            </Box>
                            <p>read more..</p>
                        </Box>
                        </Grid>*/}
                       {/*} <Grid item xs={tabletsize?phonesize?12:6:4} sx={{}}>
                        <Box sx={{marginRight:'20px',marginLeft:'20px',}}>
                        <img src={img2} alt={'Image uploading'} height='100%' width='100%' />
                            <h2>Comparing Different Engine Air Filter Materials: Which One is Right for You?</h2>
                            <Box sx={{}}>
                            <p>The engine air filter is a critical component of your vehicle's engine system. In this blog post, we will compare various engine air filter materials and help you determine which one suits your needs best.</p>
                            </Box>
                            <p>read more..</p>
                        </Box>
                        </Grid>*/}
                        </Grid>
                    </Box>
                    </Box>
                </div>
            </Container>

            {/* after successfully submitted form show success message */}
            <Snackbar
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}
                ContentProps={{
                    style: { background: "green" },
                }}
                open={successSubmit}
                autoHideDuration={5000}
                onClose={handleCloseSuccess}
                message="Your form has been submitted successfully!"
                action={
                    <IconButton
                        size="small"
                        aria-label="close"
                        color="inherit"
                        onClick={handleCloseSuccess}
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>
                }
            />
            <Footer />
        </div>
    );
}

export default AllBlogs;
